import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { PersonasCatalogKey } from './personas.i18n.js';
import { PERSONAS_CATALOG } from './personas.i18n.js';

export type PersonasMessageId = `personas:${PersonasCatalogKey}`;

const PREFIX_LENGTH = 'personas:'.length;

/** `t()` for the stop-gap `personas:` scope (see `personas.i18n.ts`). */
export function usePersonasT(): { t: (id: PersonasMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: PersonasMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as PersonasCatalogKey;
      const raw = PERSONAS_CATALOG[locale][key] ?? PERSONAS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
